import React, { Component } from 'react'
import { Form, Icon, Input, Button, Row, Col, Spin, message } from 'antd';
import { CLOUD_FUNCTION } from "../../../../../config/fbConfig"
import Axios from "axios"
const FormItem = Form.Item;
const { TextArea } = Input;

class ConcactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fullName: '',
      email: '',
      message: '',
      loading: false,
      subject: ''
    };
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSubmit(e) {
    const { fullName, email, subject, message } = this.state
    e.preventDefault();
    this.setState({
      loading: true
    })
    this.props.form.validateFields((err) => {
      if (!err) {
        Axios.post(`${CLOUD_FUNCTION}/api/contact`, {
          fullName,
          email,
          subject,
          message
        }).then((res) => {
          console.log(res)
          // this.props.form.resetFields()
        }).catch((err) => {
          console.log(err)
        })
      } else {
        this.setState({
          loading: false
        })
      }
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { loading } = this.state
    return (
      <div>
        <Form onSubmit={(e) => {
          this.handleSubmit(e);
        }}>
          <Row gutter={8}>
            <Col lg={12} md={12}>
              <FormItem>
                {getFieldDecorator('fullname', {
                  rules: [
                    {
                      required: true,
                      message: 'Please input your Fullname'
                    }
                  ]
                })(
                  <Input
                    onChange={e => this.handleChange(e)}
                    name="fullName"
                    placeholder="Fullname"
                  />
                )}
              </FormItem>
            </Col>
            <Col lg={12} md={12}>
              <FormItem>
                {getFieldDecorator('email', {
                  rules: [
                    {
                      required: true,
                      message: 'Please input your Email'
                    },
                    {
                      type: 'email',
                      message: 'The input is not valid Email'
                    }
                  ]
                })(
                  <Input
                    onChange={e => this.handleChange(e)}
                    name="email"
                    placeholder="Email"
                  />
                )}
              </FormItem>
            </Col>
          </Row>
          <FormItem>
            {getFieldDecorator('subject', {
              rules: [
                {
                  required: true,
                  message: 'Please input your Subject'
                }
              ]
            })(
              <Input
                onChange={e => this.handleChange(e)}
                name="subject"
                placeholder="Subject"
              />
            )}
          </FormItem>
          <Form.Item>
            {getFieldDecorator('message', {
              rules: [{ required: true, message: 'Please input your Message' }]
            })(
              <TextArea
                onChange={(e) => this.handleChange(e)}
                placeholder="Message"
                name="message"
              />
            )}
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} size={'large'}>
              {
                loading ? 'Sending Message' : 'Send Message'
              }
            </Button>
          </Form.Item>
        </Form>
      </div>
    )
  }
}

const WrappedConcactForm = Form.create()(ConcactForm);
export default WrappedConcactForm;